require("SimpleBarJs")
require("SimpleBarCss")
require("../app/toggle_block.coffee")
require("../app/browser_detect.coffee")
require("../app/bulletin_resize_images.coffee")
require("slick-carousel")
require("FancyboxJs")
require("FancyboxCss")


window.pageInitStaticPagePopupFlag = false

pageInit = ->
  new window.ToggleBlock()
  new window.BilletinResizeImages()
  browserDetect = new window.BrowserDetect()

  if (browserDetect.browser == 'Explorer' && browserDetect.version < 11)
    $('.table-wrapper').each ->
      $(this).css('overflow','auto')
  else
    $('.table-wrapper').each ->
      new SimpleBar($(this)[0], { autoHide: false })


  $('.news-gallery-slider .slickslide').not('.slick-initialized').slick {
    prevArrow: '<div class="home-banners-slider__arrow-left slick-arrow" style="">
                  <div class="base-icon-block">
                    <svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <use xlink:href="#slider-row"></use>
                      <defs>
                          <path id="slider-row" d="M0 10.59L4.327 6 0 1.41 1.332 0 7 6l-5.668 6L0 10.59z"></path>
                      </defs>
                    </svg>
                  </div>
                </div>'
    nextArrow: '<div class="home-banners-slider__arrow-right slick-arrow" style="">
                      <div class="base-icon-block">
                  <svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <use xlink:href="#slider-row"></use>
                      <defs>
                          <path id="slider-row" d="M0 10.59L4.327 6 0 1.41 1.332 0 7 6l-5.668 6L0 10.59z"></path>
                      </defs>
                  </svg>
              </div>
                  </div>'
    dots: true
    infinite: false
    speed: 500
    fade: false
    cssEase: 'linear'
    centerMode: true
    slidesToShow: 1
    variableWidth: true
    autoplay: true
    autoplaySpeed: 4000
    responsive: {
      breakpoint: 800
      settings:
        arrows: false
        centerMode: false
        centerPadding: '40px'
        variableWidth: false
        slidesToShow: 1
        dots: true
      breakpoint: 1200
      settings:
        arrows: false
        centerMode: false
        centerPadding: '40px'
        variableWidth: false
        slidesToShow: 1
        dots: true
    }
    customPaging: (slider, i) ->
      '<div class="tab">' + $($('.slick-thumbs li')[i]).html() + '</div>'
  }

  $('.news-gallery-slider .slickslide').on('init',
    (event, slick, direction)->
      # console.log 'hfgggf'
      $('[data-fancybox]').fancybox({
        animationEffect: "fade"
      })
  )






$(document).ready ->
  if window.pageInitStaticPagePopupFlag != true
    pageInit()
  window.pageInitStaticPagePopupFlag = true


// WEBPACK FOOTER //
// ./assets/javascripts/pages/static_page.coffee